module.exports = __webpack_public_path__ + "ecab5bd7bfd1c12c1f8502ea1c700b91.svg";